// src/pages/OpdPataintList.js
import React, { useEffect, useState, useRef, useMemo } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import 'bootstrap/dist/css/bootstrap.min.css';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { toast } from "react-toastify";
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import Select from "react-select";
import ProcedureBillModal from '../models/ProcedureBillModal';
import { useNavigate } from 'react-router-dom';



function OpdPataintList() {
 // use local date components so input[type="date"] shows the correct local date
const todayDate = (() => {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0'); // monthIndex -> 1..12
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
})();

  const [dropdownOpen, setDropdownOpen] = useState(null);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [headerLogo, setHeaderLogo] = useState('');
  const [watermarkLogo, setWatermarkLogo] = useState('');
  const [footerImage, setFooterImage] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);
const [doctorsMap, setDoctorsMap] = useState({});
// Near the top with other state declarations
const [showProcedureBill, setShowProcedureBill] = useState(false);
const [procedurePatientData, setProcedurePatientData] = useState(null);
  const dropdownRefs = useRef([]);
// pagination state (server-side)
const [pageNo, setPageNo] = useState(0);     // 0-based page index
const [pageSize, setPageSize] = useState(15); // must match backend page_size
const [totalCount, setTotalCount] = useState(0);

  const [formData, setFormData] = useState({
    l1: [],
    doc: [],
    page_no: 0,
    from: todayDate,
    to: todayDate,
    alertMsg: '',
    alertMsgTyp: '',
    search_key: '',
    isAlert: false,
    selectedDoctorId: '' 
  });

  const [totals, setTotals] = useState({
    totalAmount: 0,
    discountAmount: 0,
    paidAmount: 0,
    dueAmount: 0,
    totalCharges: 0
  });
{/* put this inside the component return (just inside <div className="page-content">) */}
// put near your other helper functions
const navigate = useNavigate();

// Add this ExpandedActions component (place it before the columns definition):
const ExpandedActions = ({ data: row }) => {
  const toLabPrefill = async () => {
    if (!row) return;

    const labPayload = {
      // Patient identification
      lab_reg_uhid: row.opd_uhid || row.uhid || "",
      lab_reg_id: "", // new registration
      
      // Patient details
      lab_reg_name_title: row.opd_patient_title || "Mr.",
      lab_reg_name: row.opd_patient_name || "",
      lab_reg_gender: row.opd_patient_gender || "Male",
      lab_reg_address: row.opd_address || "",
      lab_reg_city: row.opd_city || "",
      lab_reg_state: row.opd_state || "",
      lab_reg_mobile: row.opd_patient_mobile || "",
      
      // Age fields - from OPD guardian age
      lab_reg_age_year: row.opd_guardien_years || row.opd_patient_age || "0",
      lab_reg_age_month: row.opd_guardien_months||"0",
      lab_reg_age_day: "0",
      
      // Guardian
      lab_guardian_title: row.opd_guardien_title || "C/O",
      lab_guardian_name: row.opd_guardien_name || "",
      
      // Referral doctor - use consult doctor from OPD
      lab_reg_referral: row.consult_doctor_name || resolveDoctorLabel(row) || "",
      lab_reg_referral_id: row.opd_concult_doctor || row.opd_refer_doctor || "",
      
      // Registration details
      lab_reg_type: "OPD", // Mark as OPD source
      lab_reg_date: (() => {
        const src = row.opd_datetime || row.opd_reg_date || "";
        if (!src) return "";
        try {
          const dt = parseToLocalDate(src);
          if (!dt || isNaN(dt.getTime())) return String(src);
          const YYYY = dt.getFullYear();
          const MM = String(dt.getMonth() + 1).padStart(2, "0");
          const DD = String(dt.getDate()).padStart(2, "0");
          return `${YYYY}-${MM}-${DD}`;
        } catch (e) {
          return String(src);
        }
      })(),
      
      // Collection location
      lab_collected_at: "",
      
      // Payment defaults (lab will calculate based on tests)
      lab_total: "0",
      lab_dis_per: "0",
      lab_fix_deposit: "0",
      lab_final_amt: "0",
      lab_paid: "0",
      lab_due: "0",
      lab_pay_mode: "Cash",
      lab_remarks: `Referred from OPD - Reg No: ${row.opd_id || ''}`,
      
      // Tests array (empty - user will select)
      tests1: [],
      params: [],
      all_tests: [],
      
      // Metadata flags
      is_prefilled: true,
      source_type: "opd",
      source_id: row.opd_id || "",
    };

    console.log("🔵 OPD Lab prefill payload:", labPayload);

    try {
      sessionStorage.setItem('lab_prefill', JSON.stringify(labPayload));
      console.log("✅ Lab data saved to sessionStorage from OPD");
    } catch (e) {
      console.warn('Could not set lab_prefill in sessionStorage', e);
      toast.error('Failed to prepare lab registration');
      return;
    }

    navigate('/registrations');
  };



 const toEmergencyPrefill = () => {
    if (!row) return;

    const emergencyPayload = {
      ipd_id: '',
      ipd_uhid: row.opd_uhid || '',
      ipd_patient_title: row.opd_patient_title || 'Mr.',
      ipd_patient_name: row.opd_patient_name || '',
      ipd_patient_gender: row.opd_patient_gender || 'Male',
      ipd_patient_mobile: row.opd_patient_mobile || '',
      ipd_guardien_title: row.opd_guardien_title || 'C/O',
      ipd_guardien_name: row.opd_guardien_name || '',
      ipd_address: row.opd_address || '',
      ipd_city: row.opd_city || '',
      ipd_age_year: row.opd_guardien_years || row.opd_patient_age || '',
      ipd_age_month: row.opd_guardien_months || '',
      ipd_age_day: '',
      ipd_specality: row.opd_specality || '',
      ipd_refer_doctor: row.opd_concult_doctor || row.opd_refer_doctor || '',
      ipd_type: 'New Visit',
      ipd_remarks: `Referred from OPD - Reg No: ${row.opd_id || ''}`,
    };

    try {
      sessionStorage.setItem('emergency_dt', JSON.stringify(emergencyPayload));
      console.log("✅ Emergency prefill saved to sessionStorage from OPD");
    } catch (e) {
      console.warn('Could not set emergency_dt in sessionStorage', e);
      toast.error('Failed to prepare emergency registration');
      return;
    }

    navigate('/emergency_reg');
  };

  return (
    <div style={{ 
      padding: '10px 14px', 
      borderTop: '1px solid #eee', 
      display: 'flex', 
      gap: '8px', 
      flexWrap: 'wrap', 
      alignItems: 'center',
      backgroundColor: '#f8f9fa'
    }}>
      <button 
        className="btn btn-sm btn-outline-primary" 
        onClick={toLabPrefill}
        title="Add Lab Registration"
      >
        <i className="ri-flask-line"></i>&nbsp;Add Lab
      </button>

      {/* ✅ NEW: Add Emergency/DayCare button */}
      <button 
        className="btn btn-sm btn-outline-danger" 
        onClick={toEmergencyPrefill}
        title="Add Emergency / DayCare Registration"
      >
        <i className="ri-hospital-line"></i>&nbsp;Add DayCare / Emergency
      </button>
    </div>
  );
};







// parse many common server date formats into a LOCAL Date reliably
function parseToLocalDate(dtStr) {
  if (!dtStr) return null;
  const s = String(dtStr).trim();

  // 1) If it's already a Date object
  if (s instanceof Date) return s;

  // 2) If ISO with timezone (contains 'Z' or +/-HH:mm) -> let Date parse (it will convert to local)
  if (/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:?\d{2})?$/.test(s)) {
    const d = new Date(s);
    return isNaN(d.getTime()) ? null : d;
  }

  // 3) MySQL-ish "YYYY-MM-DD HH:mm:ss" or "YYYY-MM-DD" -> parse components and construct local Date
  const mysqlLike = s.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}):?(\d{2})?)?$/);
  if (mysqlLike) {
    const year = parseInt(mysqlLike[1], 10);
    const month = parseInt(mysqlLike[2], 10) - 1;
    const day = parseInt(mysqlLike[3], 10);
    const hour = mysqlLike[4] ? parseInt(mysqlLike[4], 10) : 0;
    const minute = mysqlLike[5] ? parseInt(mysqlLike[5], 10) : 0;
    const second = mysqlLike[6] ? parseInt(mysqlLike[6], 10) : 0;
    // create a LOCAL date (year, monthIndex, day, hour, minute, second)
    const d = new Date(year, month, day, hour, minute, second);
    return isNaN(d.getTime()) ? null : d;
  }

  // 4) fallback: try Date constructor once
  const d = new Date(s);
  return isNaN(d.getTime()) ? null : d;
}
// Normalize a date-like value to 'YYYY-MM-DD' (works with Date, ISO, or html date string)
const normalizeDateToYYYYMMDD = (raw) => {
  if (!raw && raw !== '') return '';
  const s = String(raw).trim();
  if (s === '') return '';
  // if already yyyy-mm-dd
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  // dd/mm/yyyy -> convert
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(s)) {
    const [d, m, y] = s.split('/');
    return `${y}-${m.padStart(2,'0')}-${d.padStart(2,'0')}`;
  }
  // try Date
  const dt = new Date(s);
  if (!isNaN(dt.getTime())) return dt.toISOString().split('T')[0];
  return s; // fallback return raw
};

const validateFromTo = (fromRaw, toRaw) => {
  const from = normalizeDateToYYYYMMDD(fromRaw);
  const to = normalizeDateToYYYYMMDD(toRaw);
  if (!from || !to) return { ok: false, msg: 'Please select both From and To dates', from, to };
  if (new Date(from) > new Date(to)) return { ok: false, msg: 'From date cannot be after To date', from, to };
  return { ok: true, from, to };
};

// replace your formatDateTime with this (uses parseToLocalDate)
function formatDateTime(dtStr) {
  const d = parseToLocalDate(dtStr);
  if (!d) return '';

  const dd = String(d.getDate()).padStart(2, "0");
  const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
  const mon = months[d.getMonth()];
  const yyyy = d.getFullYear();

  // 12-hour time
  let hh = d.getHours();
  const ampm = hh >= 12 ? "PM" : "AM";
  hh = hh % 12;
  if (hh === 0) hh = 12;
  const mm = String(d.getMinutes()).padStart(2, "0");

  return `${dd}-${mon}-${yyyy} ${String(hh).padStart(2, "0")}:${mm} ${ampm}`;
}

// show details modal + visit history (same UHID)
const openDetails = (row) => {
  if (!row) return;

  // determine uhid field (OPD may store moved uhid differently)
  const uhid = row.opd_uhid || row.opd_uhid_move || row.opd_uhid || '';

  const fmt = (val) => {
    if (!val) return '';
    const d = new Date(val);
    if (!isNaN(d.getTime())) return d.toLocaleString();
    return String(val);
  };

  // main info
  const mainHtml = `
    <div style="text-align:left; font-size:13px; line-height:1.45;">
      <b>UHID:</b> ${uhid || 'N/A'}<br/>
      <b>Patient Name:</b> ${row.opd_patient_name || 'N/A'}<br/>
      <b>Age:</b> ${row.opd_guardien_age || row.opd_patient_age || 'N/A'}<br/>
      <b>Referred Doctor:</b> ${resolveDoctorLabel(row)}<br/>

      <b>Status:</b> ${row.opd_type || 'N/A'}<br/>
    </div>
  `;

  // build visit history: find rows in formData.l1 which share the UHID
  const all = Array.isArray(formData.l1) ? formData.l1.slice() : [];
  const sameUhid = all.filter(r => {
    const rUhid = r.opd_uhid || r.opd_uhid_move || '';
    return uhid && String(rUhid) === String(uhid);
  });

  // sort by datetime desc (use opd_datetime, fallback to reg date or opd_id)
  sameUhid.sort((a,b) => {
    const getTime = (x) => {
      const cand = x.opd_datetime || x.opd_reg_date || x.created_at || '';
      const dt = new Date(cand);
      return isNaN(dt.getTime()) ? 0 : dt.getTime();
    };
    return getTime(b) - getTime(a);
  });

  let historyHtml = '<div style="margin-top:10px; text-align:left;">';
  if (sameUhid.length === 0) {
    historyHtml += '<b>Visit History:</b> None found for this UHID.';
  } else {
    historyHtml += `<b>Visit History (most recent first):</b>
      <table style="width:100%; border-collapse:collapse; margin-top:6px; font-size:13px;">
        <thead>
          <tr>
            <th style="text-align:left; padding:6px; border-bottom:1px solid #eaeaea;">Date & Time</th>
            <th style="text-align:left; padding:6px; border-bottom:1px solid #eaeaea;">Reg. No</th>
            <th style="text-align:left; padding:6px; border-bottom:1px solid #eaeaea;">Type</th>
            <th style="text-align:left; padding:6px; border-bottom:1px solid #eaeaea;">Notes</th>
          </tr>
        </thead>
        <tbody>
    `;
    sameUhid.forEach(r => {
      const dt = fmt(r.opd_datetime || r.opd_reg_date || r.created_at);
      const regNo = r.opd_id ? r.opd_id : '-';
      const type = r.opd_type || 'OPD';
      const notes = (r.opd_remark || r.opd_reason || '').toString().slice(0, 120) || '-';
      historyHtml += `
        <tr>
          <td style="padding:6px; border-bottom:1px solid #f7f7f7;">${dt}</td>
          <td style="padding:6px; border-bottom:1px solid #f7f7f7;">${regNo}</td>
          <td style="padding:6px; border-bottom:1px solid #f7f7f7;">${type}</td>
          <td style="padding:6px; border-bottom:1px solid #f7f7f7;">${notes}</td>
        </tr>
      `;
    });
    historyHtml += `</tbody></table>`;
  }
  historyHtml += '</div>';

  const content = `${mainHtml}${historyHtml}`;

  Swal.fire({
    title: 'Patient Details',
    html: content,
    width: 820,
    showCloseButton: true,
    focusConfirm: false,
    confirmButtonText: 'Close'
  });
};

  const [ldata, setLdata] = useState(null);

  const doctorOptions = useMemo(() => {
    const map = new Map();
  
    // 1) prefer explicit doctor list from backend (formData.doc)
    if (Array.isArray(formData.doc)) {
      formData.doc.forEach((d, i) => {
        try {
          const id = d?.user_id ?? d?.id ?? d?.userId ?? d?.doctor_id ?? d?.doc?.doc_parent ?? d?.doc?.doc_id ?? d?.doc?.doc_user ?? `doc_backend_${i}`;
          const label = (d?.fname || d?.name || d?.full_name || d?.username || d?.doc?.doc_name || String(id)).toString().trim();
          if (id != null && String(id).trim() !== "" && label) map.set(String(id), label);
        } catch (e) { /* ignore malformed */ }
      });
    }
  
    // 2) fallback: extract names/ids from OPD rows (formData.l1)
    if (Array.isArray(formData.l1)) {
      formData.l1.forEach((r, i) => {
        try {
          // possible id-like fields that may refer to doctor
          const idCandidates = [r.opd_concult_doctor, r.opd_refer_doctor, r.doctor_id, r.opd_doc_id, r.opd_doc, r.opd_refer_doc];
          let id = idCandidates.find(x => x !== undefined && x !== null && String(x).trim() !== "");
          if (id === undefined || id === null) {
            // sometimes OPD only has the doctor name, not id
            id = r.consult_doctor_name ?? r.opd_concult_doctor_name ?? r.opd_refer_doctor_name ?? r.doctor_name ?? null;
          }
          const label = (r.consult_doctor_name || r.opd_concult_doctor_name || r.opd_refer_doctor_name || r.doctor_name || (id ? String(id) : `Doc ${i+1}`)).toString().trim();
  
          // create a safe key even if id is a name string
          const key = id !== undefined && id !== null ? String(id).trim() : `opd_doc_${i}`;
          if (key && label) map.set(key, label);
        } catch (e) { /* ignore malformed */ }
      });
    }
  
    // convert to sorted array (by label)
    const arr = Array.from(map.entries()).map(([value, label]) => ({ value, label }));
    arr.sort((a, b) => a.label.localeCompare(b.label));
    return arr;
  }, [formData.doc, formData.l1]);
// --- robust helpers for doctor id/label ---
function getDoctorIdFromRow(d, idx) {
  if (!d) return `doc_${idx}`;
  const candidates = [
    d?.user_id, d?.id, d?.userId, d?.doctor_id,
    d?.doc?.doc_parent, d?.doc?.doc_user, d?.doc?.doc_id,
    d?.emp_id, d?.uid
  ];
  let k = candidates.find(x => x !== undefined && x !== null && String(x).trim() !== "");
  if (k === undefined || k === null) {
    // sometimes backend returns the id inside top-level 'doc_id' or nested differently
    k = d?.doc_id ?? d?.docParent ?? d?.doc_parent ?? null;
  }
  if (k === undefined || k === null || String(k).trim() === "") return `doc_${idx}`;
  return String(k).trim();
}

function getDoctorLabelFromRow(d) {
  if (!d) return "";
  // common name fields
  let name = (d.fname || d.name || d.full_name || (d.doc && d.doc.doc_name) || d.username || "").toString().trim();

  // try fname + lname if present
  if (!name && (d.fname || d.lname)) {
    name = `${d.fname || ""} ${d.lname || ""}`.trim();
  }

  // sometimes d.doc is stringified JSON
  if ((!name || name === "") && d.doc && typeof d.doc === "string") {
    try {
      const parsed = JSON.parse(d.doc);
      name = (parsed.doc_name || parsed.name || parsed.full_name || "").toString().trim();
    } catch (e) {
      // fallback: use raw doc string
      name = String(d.doc).trim();
    }
  }

  // fallback to registration / degree if available
  if ((!name || name === "") && d?.doc && (d.doc.doc_degree || d.doc.doc_specality)) {
    const degree = d.doc.doc_degree || d.doc.doc_specality || "";
    name = degree.toString().trim();
  }

  return name || ""; // may be empty, caller will fallback to id
}

  // Helper: determine if record editable (admin, not moved to IPD, within 24h)
  // Helper: determine if record editable (admin anytime, non-admin within 24h)



// Helper: determine if record editable
// helper: synchronous check for logged-in role (reads sessionStorage)
const getLoggedRoleId = () => {
  try {
    const raw = sessionStorage.getItem('ldata') || localStorage.getItem('ldata') || localStorage.getItem('data') || sessionStorage.getItem('data');
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    // handle multiple naming variants
    return parsed?.role_id ?? parsed?.roleId ?? parsed?.role ?? null;
  } catch (e) {
    return null;
  }
};

// Helper: determine if record editable
const isEditableRecord = (record) => {
  if (!record) return false;

  // Always block edit if moved to IPD
  if (record.opd_type === "Move to IPD") return false;

  // If logged-in user is role_id === 1, allow editing (admin)
  const roleId = String(getLoggedRoleId() ?? '').trim();
  if (roleId === '1') return true;

  // If no datetime, allow editing for regular users (change if you want different)
  if (!record.opd_datetime) return true;

  // Otherwise allow within 24 hours
  const recDate = new Date(record.opd_datetime);
  if (isNaN(recDate.getTime())) return false;
  const now = new Date();
  return (now - recDate) < (24 * 60 * 60 * 1000); // 24 hours
};


const loggedUser = useMemo(() => {
  try {
    return JSON.parse(sessionStorage.getItem("ldata") || "{}");
  } catch {
    return {};
  }
}, []);

const isDoctorLogin = loggedUser?.type === 'doctor';
const loggedDoctorId = loggedUser?.user_id
  ? String(loggedUser.user_id)
  : '';


  function formatDateTime(dtStr) {
    if (!dtStr) return "";
    try {
      // try Date parse first (works for many formats)
      let d = new Date(dtStr);
      if (isNaN(d.getTime())) {
        // fallback: replace space with 'T' (common server format "YYYY-MM-DD HH:mm:ss")
        const t = String(dtStr).trim().replace(" ", "T");
        d = new Date(t);
      }
      if (isNaN(d.getTime())) return String(dtStr);
  
      const dd = String(d.getDate()).padStart(2, "0");
      const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
      const mon = months[d.getMonth()];
      const yyyy = d.getFullYear();
  
      // 12-hour time
      let hh = d.getHours();
      const ampm = hh >= 12 ? "PM" : "AM";
      hh = hh % 12;
      if (hh === 0) hh = 12;
      const mm = String(d.getMinutes()).padStart(2, "0");
  
      return `${dd}-${mon}-${yyyy} ${String(hh).padStart(2, "0")}:${mm} ${ampm}`;
    } catch (e) {
      return String(dtStr);
    }
  }
  // doctor matching logic (unchanged)

// robust helper: give me a friendly doctor label for a row's doctor id/name
function resolveDoctorLabel(row) {
  if (!row) return 'N/A';

  // prefer an explicit name field on the row
  const explicit = row.opd_concult_doctor_name || row.consult_doctor_name || row.opd_refer_doctor_name || row.doctor_name;
  if (explicit && String(explicit).trim() !== '') return String(explicit).trim();

  // try doctorsMap (fast lookup built in initData2)
  const id = (row.opd_concult_doctor ?? row.opd_refer_doctor ?? row.doctor_id ?? '').toString();
  if (id && doctorsMap && doctorsMap[id]) return doctorsMap[id];

  // try formData.doc array with flexible matching
  if (Array.isArray(formData.doc)) {
    const candidate = formData.doc.find(d => {
      if (!d) return false;
      const keys = [
        d.user_id, d.id, d.userId, d.doctor_id,
        d.doc?.doc_parent, d.doc?.doc_user, d.doc?.doc_id
      ].map(x => x === undefined || x === null ? '' : String(x).trim().toLowerCase());

      return keys.includes(id.trim().toLowerCase());
    });
    if (candidate) return (candidate.fname || candidate.name || candidate.full_name || candidate.doc?.doc_name || id).toString();
  }

  // fallback: attempt to find name inside formData.l1 rows with same id
  if (Array.isArray(formData.l1)) {
    const matched = formData.l1.find(r => {
      const candIds = [r.opd_concult_doctor, r.opd_refer_doctor, r.doctor_id, r.opd_doc_id].map(x => x === undefined || x === null ? '' : String(x).trim().toLowerCase());
      return candIds.includes(id.trim().toLowerCase());
    });
    if (matched && (matched.opd_concult_doctor_name || matched.consult_doctor_name || matched.doctor_name)) {
      return (matched.opd_concult_doctor_name || matched.consult_doctor_name || matched.doctor_name).toString();
    }
  }

  // final fallback: return id (so UI still shows something)
  return id || 'N/A';
}


  function getDoctorNameById(id, fallbackName) {
    if (id === undefined || id === null || id === '') {
      return fallbackName ? fallbackName : 'N/A';
    }
    const strId = String(id).trim();
    const docs = Array.isArray(formData.doc) ? formData.doc : [];

    const doctorById = docs.find(d => {
      if (!d) return false;
      const candidates = [
        d.user_id,
        d.id,
        d.doc?.doc_parent,
        d.doc?.doc_id,
        d.doc?.doc_user
      ].filter(Boolean);
      return candidates.some(c => String(c).trim() === strId);
    });

    if (doctorById) {
      const name = (doctorById.fname || doctorById.name || doctorById.full_name || '').trim();
      const degree = doctorById.doc?.doc_degree ? doctorById.doc.doc_degree.trim() : '';
      const spec = doctorById.doc?.doc_specality ? doctorById.doc.doc_specality.trim() : '';
      const extra = [degree, spec].filter(Boolean).join(' / ');
      return extra ? `${name} (${extra})` : (name || 'Doctor');
    }

    if (fallbackName) {
      const nameLower = String(fallbackName).toLowerCase();
      const doctorByName = docs.find(d => {
        const full = `${d.fname || ''} ${d.lname || ''} ${d.doc?.doc_reg_number || ''}`.toLowerCase();
        return full.includes(nameLower);
      });
      if (doctorByName) {
        const name = (doctorByName.fname || doctorByName.name || '').trim();
        const degree = doctorByName.doc?.doc_degree ? doctorByName.doc.doc_degree.trim() : '';
        const spec = doctorByName.doc?.doc_specality ? doctorByName.doc.doc_specality.trim() : '';
        const extra = [degree, spec].filter(Boolean).join(' / ');
        return extra ? `${name} (${extra})` : (name || 'Doctor');
      }
    }

    return `Doctor not found (ref: ${strId}${fallbackName ? `, name:'${fallbackName}'` : ''})`;
  }
// robust doctor option builder (put it near other helper functions)
// robust doctor option builder (guarantees value + label)
function buildDoctorOptions(doctorsArray = []) {
  if (!Array.isArray(doctorsArray)) return [];

  const map = new Map();
  doctorsArray.forEach((d, idx) => {
    try {
      // collect many candidate keys (common shapes)
      const candidates = [
        d?.user_id, d?.id, d?.userId, d?.doctor_id,
        d?.doc?.doc_parent, d?.doc?.doc_user, d?.doc?.doc_id,
        d?.emp_id, d?.uid
      ];

      // pick first non-empty candidate
      let key = candidates.find(k => k !== undefined && k !== null && String(k).trim() !== "");
      if (key !== undefined && key !== null) key = String(key).trim();

      // label extraction: many possibilities
      let label = "";
      if (d == null) label = "";
      else if (typeof d === "string") {
        label = d.trim();
      } else {
        label = (d.fname || d.name || d.full_name || d.username || d?.doc?.doc_name || d?.doc?.doc_reg_name || "").toString().trim();
        // if nested doc is a JSON string, attempt parse
        if ((!label || label === "") && d.doc && typeof d.doc === "string") {
          try {
            const parsed = JSON.parse(d.doc);
            label = (parsed.doc_name || parsed.name || parsed.full_name || "").toString().trim();
          } catch (e) {
            // fallback to raw doc string
            label = String(d.doc).trim();
          }
        }
      }

      // final fallbacks
      if (!label && key) label = key;
      if (!key && label) key = label;
      // if still missing, create index-based key and label
      if (!key) key = `doc_${idx}`;
      if (!label) label = `Doctor ${idx + 1}`;

      // dedupe by key and keep first label encountered
      if (!map.has(key)) map.set(key, label);
    } catch (ex) {
      console.warn("buildDoctorOptions skip item", d, ex);
    }
  });

  const arr = Array.from(map.entries()).map(([value, label]) => ({ value, label }));
  arr.sort((a, b) => a.label.localeCompare(b.label));
  return arr;
}

{/* put this inside the component return, near the top (just below the outermost div) or in your stylesheet */}
<style>{`
  .marquee-wrap {
    overflow: hidden;
    position: relative;
    width: 160px;           /* adjust width to fit column */
    height: 28px;           /* adjust to match your table row height */
    display: inline-block;
    vertical-align: middle;
  }
  .marquee {
    display: inline-block;
    white-space: nowrap;
    padding-left: 100%;
    box-sizing: content-box;
    animation: marquee 8s linear infinite;
    font-weight: 700;
    color: #ffffff;
    background: #198754;   /* green, match your success color */
    border-radius: 6px;
    padding: 4px 10px;
    line-height: 20px;
  }
  .marquee:hover {
    animation-play-state: paused; /* pause on hover */
  }

  @keyframes marquee {
    0% { transform: translateX(0%); }
    100% { transform: translateX(-100%); }
  }

  /* responsive tweak: shorter animation for small screens */
  @media (max-width: 600px) {
    .marquee { animation-duration: 5s; }
    .marquee-wrap { width: 120px; height: 26px; }
  }
`}</style>

  // load doctors list and detect admin role
 // load doctors list and detect admin role
// simple fetch doctors
const initData2 = async () => {
  try {
    const fd = new FormData();
    fd.append('type', 'doctor');
    fd.append('page_no', 'none');
    fd.append('user_cre_by', 'all');

    const response = await axios.post(
      AppConst.BASE_URL + AppConst.getUserListUrl,
      fd,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );

    if (response?.data?.status && Array.isArray(response.data.records)) {
      const doctors = response.data.records;

      setFormData(prev => {
        // ✅ decide INSIDE updater
        if (
          isDoctorLogin &&
          loggedDoctorId &&
          !prev.selectedDoctorId
        ) {
          return {
            ...prev,
            doc: doctors,
            selectedDoctorId: loggedDoctorId
          };
        }

        return {
          ...prev,
          doc: doctors
        };
      });
    }
  } catch (err) {
    console.error("initData2 error", err);
  }
};




// inside OpdPataintList component (near other functions)
const toggleDone = async (row) => {
  if (!row || !row.opd_id) return;
  // if already done, do nothing (or optionally allow un-doing)
  if (Number(row.done) === 1) {
    toast.info("Already marked done.");
    return;
  }

  // optimistic update locally
  setFormData(prev => {
    const newL1 = (prev.l1 || []).map(r => (r.opd_id === row.opd_id ? { ...r, done: 1 } : r));
    return { ...prev, l1: newL1 };
  });

  try {
    const fd = new FormData();
    fd.append('opd_id', row.opd_id + "");
    fd.append('done', '1'); // set 1
    const resp = await axios.post(AppConst.BASE_URL + AppConst.updateOpdDoneUrl, fd, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    if (resp?.data?.status) {
      toast.success(resp.data.success || 'Marked done');
      // optionally refresh from server:
      // await initData();
    } else {
      // revert optimistic update if server failed
      setFormData(prev => {
        const newL1 = (prev.l1 || []).map(r => (r.opd_id === row.opd_id ? { ...r, done: row.done ?? 0 } : r));
        return { ...prev, l1: newL1 };
      });
      toast.error(resp?.data?.error || 'Failed to mark done');
    }
  } catch (err) {
    // revert optimistic update
    setFormData(prev => {
      const newL1 = (prev.l1 || []).map(r => (r.opd_id === row.opd_id ? { ...r, done: row.done ?? 0 } : r));
      return { ...prev, l1: newL1 };
    });
    console.error("toggleDone error:", err);
    toast.error("Network error updating status");
  }
};


  // load OPD list
    // load OPD list
    // track last response to detect identical results (helps detect 0-vs-1 based server)
const lastResponseRef = useRef({ page: null, recordsHash: null });

// Replace the existing initData function with this updated version:
const initData = async (opts = {}) => {
  // opts can include { page: number, size: number, resetPage: boolean }
  const p = opts.page ?? pageNo;
  const size = opts.size ?? pageSize;

  // Build FormData (server may expect 0-based or 1-based; we send p first and retry once with p+1 if server returns identical rows)
  const sendRequest = async (useOneBased = false) => {
    const fd = new FormData();
    const serverPage = useOneBased ? (p + 1) : p; // try 0-based first, optionally retry with 1-based
    fd.append('page_no', String(serverPage));
    fd.append('page_size', String(size));
    
    const searchKey = (formData.search_key || "").toString().trim();
    
    // ✅ IF SEARCH KEY EXISTS, IGNORE DATE FILTERING - fetch all data
    if (searchKey !== "") {
      console.log("🔍 Search active - ignoring dates, searching:", searchKey);
      fd.append('search_key', searchKey);
      fd.append('from', ""); // ✅ Empty = fetch all
      fd.append('to', "");
    } else {
      // ✅ NO SEARCH - apply date filters
      console.log("📅 No search - using date range");
      fd.append('search_key', "");
      if (formData.from) fd.append('from', formData.from);
      if (formData.to) fd.append('to', formData.to);
    }

    try {
      const response = await axios.post(AppConst.BASE_URL + AppConst.getOpdListUrl, fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      console.debug("initData response:", {
        sentPage: serverPage,
        requestedPage: p,
        pageSize: size,
        data: response?.data
      });

      if (response?.data && response.data.status) {
        const records = response.data.records || [];

        // compute simple hash to detect identical pages (by comparing ids order)
        const recordsHash = records.map(r => r.opd_id).join('|');

        // if server returned same rows as previous fetch for a different page, maybe server expects 1-based index.
        const last = lastResponseRef.current;
        if (!useOneBased && last.recordsHash && last.recordsHash === recordsHash && p > 0) {
          // retry once with 1-based page number
          console.warn("Detected identical records for different page; retrying with 1-based page_no...");
          const retryResponse = await sendRequest(true);
          return retryResponse;
        }

        // success: update state
        setFormData(prev => ({ ...prev, l1: records }));

        // set total & page size if returned by backend
        if (typeof response.data.total !== 'undefined') {
          setTotalCount(Number(response.data.total) || 0);
        }
        if (typeof response.data.page_size !== 'undefined') {
          setPageSize(Number(response.data.page_size) || size);
        }

        // update lastResponseRef for future comparisons
        lastResponseRef.current = { page: serverPage, recordsHash };

        // update local pageNo to reflect the *zero-based* page we intend to represent
        // If server used 1-based, and we retried with useOneBased true, set pageNo to p (which was zeroBased)
        setPageNo(p);

        return { success: true, recordsLength: records.length, data: response.data };
      } else {
        setFormData(prev => ({ ...prev, l1: [] }));
        setTotalCount(0);
        return { success: false };
      }
    } catch (err) {
      console.error("Error fetching OPD list", err);
      setFormData(prev => ({ ...prev, l1: [] }));
      setTotalCount(0);
      return { success: false, error: err };
    }
  };

  // make initial request (will internally retry once if needed)
  await sendRequest(false);
};
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const delItem = async (editItem) => {
    if (!window.confirm("Are you sure want to delete this record?")) return;
    const fd = new FormData();
    fd.append('opd_id', editItem.opd_id + "");
    try {
      const response = await axios.post(AppConst.BASE_URL + AppConst.delOpdUrl, fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      if (response.data.status) {
        await initData();
        toast.success("deleted successfully");
      }
    } catch (err) {
      console.error("Delete error", err);
      toast.error("Delete Error : " + err);
    }
  };



  // Add this useEffect to trigger search when search_key changes
useEffect(() => {
  // Don't run on initial mount (empty search)
  if (formData.search_key === '') {
    return;
  }
  
  // Debounce search
  const searchTimer = setTimeout(() => {
    console.log("🔍 Search triggered:", formData.search_key);
    initData({ page: 0, size: pageSize });
  }, 500);

  return () => clearTimeout(searchTimer);
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [formData.search_key]);
// ✅ Force close dropdowns when modal opens
useEffect(() => {
  if (showProcedureBill) {
    // Close dropdown immediately
    setOpenDropdownId(null);
    
    // Add body class for CSS targeting
    document.body.classList.add('modal-open');
    
    // Force hide all Bootstrap dropdowns
    const dropdowns = document.querySelectorAll('.dropdown-menu.show');
    dropdowns.forEach(dropdown => {
      dropdown.classList.remove('show');
    });
  } else {
    document.body.classList.remove('modal-open');
  }
  
  return () => {
    document.body.classList.remove('modal-open');
  };
}, [showProcedureBill]);
  useEffect(() => {
    const loadAll = async () => {
      const storedData = sessionStorage.getItem("ldata");
      if (storedData) setLdata(JSON.parse(storedData));
      await initData2(); // fetch doctors first
      await initData();  // then fetch OPD list
    };
    loadAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  

  // displayedRows: apply search and date-range filters client-side
  // REPLACE your existing displayedRows useMemo with this:

const displayedRows = useMemo(() => {
  let list = formData.l1 || [];
  const sKey = (formData.search_key || '').trim().toLowerCase();
  
  // ✅ SEARCH MODE: When searching, SKIP date filtering entirely
  const isSearching = sKey !== "";

  // basic text search
  if (isSearching) {
    list = list.filter(item =>
      (`${item.opd_uhid || ''}`).toLowerCase().includes(sKey) ||
      (`${item.opd_id || ''}`).toLowerCase().includes(sKey) ||
      (`${item.opd_patient_mobile || ''}`).toLowerCase().includes(sKey) ||
      (`${item.opd_patient_name || ''}`).toLowerCase().includes(sKey) ||
      (`${item.opd_guardien_name || ''}`).toLowerCase().includes(sKey) ||
      (`${item.opd_address || ''}`).toLowerCase().includes(sKey)
    );
    // ✅ NO DATE FILTER when searching - show all matching results regardless of date
    console.log("🔍 Search active - skipping date filter, found:", list.length, "rows");
  } else {
    // ✅ Only apply date filter when NOT searching
    const fromRaw = formData.from ? String(formData.from).trim() : "";
    const toRaw = formData.to ? String(formData.to).trim() : "";

    // Build start and end of day in local time
    let fromStart = null;
    let toEnd = null;

    if (fromRaw) {
      const parsedFrom = parseToLocalDate(fromRaw);
      if (parsedFrom) {
        // Start of day (00:00:00)
        fromStart = new Date(
          parsedFrom.getFullYear(),
          parsedFrom.getMonth(),
          parsedFrom.getDate(),
          0, 0, 0, 0
        ).getTime();
      }
    }

    if (toRaw) {
      const parsedTo = parseToLocalDate(toRaw);
      if (parsedTo) {
        // End of day (23:59:59.999)
        toEnd = new Date(
          parsedTo.getFullYear(),
          parsedTo.getMonth(),
          parsedTo.getDate(),
          23, 59, 59, 999
        ).getTime();
      }
    }

    // Apply date filtering only if from/to is set AND not searching
    if (fromStart !== null || toEnd !== null) {
      list = list.filter(item => {
        // ✅ If record has no datetime, INCLUDE it (don't exclude)
        if (!item.opd_datetime) return true;
        
        const recDate = parseToLocalDate(item.opd_datetime);
        if (!recDate) return true; // Include if can't parse date
        
        const recTime = recDate.getTime();

        if (fromStart !== null && recTime < fromStart) return false;
        if (toEnd !== null && recTime > toEnd) return false;
        return true;
      });
    }
  }

  // doctor filter (selectedDoctorId may be an id or sometimes a name) - always applies
  const selectedDoc = (formData.selectedDoctorId || "").toString().trim();
  if (selectedDoc !== "") {
    list = list.filter(item => {
      const candidateIds = [
        item.opd_concult_doctor,
        item.opd_refer_doctor,
        item.doctor_id,
        item.opd_doc_id,
        item.doc?.doc_parent
      ].map(x => x === undefined || x === null ? "" : String(x).trim());

      const candidateNames = [
        item.consult_doctor_name,
        item.opd_concult_doctor_name,
        item.opd_refer_doctor_name,
        item.doctor_name,
        item.opd_doc_name
      ].map(x => x === undefined || x === null ? "" : String(x).trim().toLowerCase());

      // exact id match
      if (candidateIds.some(id => id === selectedDoc)) return true;

      // exact name match or includes (lowercase)
      if (candidateNames.some(n => n === selectedDoc.toLowerCase() || n.includes(selectedDoc.toLowerCase()))) return true;

      // fallback: doctorsMap lookup (if initData2 created it)
      if (doctorsMap && doctorsMap[selectedDoc] === selectedDoc) return true;

      return false;
    });
  }

  return list;
}, [formData.l1, formData.search_key, formData.from, formData.to, formData.selectedDoctorId, doctorsMap]);
useEffect(() => {
  let totalAmount = 0, discountAmount = 0, paidAmount = 0, dueAmount = 0, totalCharges = 0;
  let procBillAmount = 0, procBillCash = 0, procBillCard = 0, procBillOnline = 0;
  displayedRows.forEach(item => {
    totalAmount += parseFloat(item.opd_final_amt || 0);
    discountAmount += parseFloat(item.opd_discount || 0);
    paidAmount += parseFloat(item.opd_paid || 0);
    dueAmount += parseFloat(item.opd_due || 0);
    totalCharges += parseFloat(item.opd_reg_fees || 0);
    // Procedure bill totals
    procBillAmount += parseFloat(item.procedure_bill_amount || 0);
    procBillCash += parseFloat(item.procedure_bill_cash || 0);
    procBillCard += parseFloat(item.procedure_bill_card || 0);
    procBillOnline += parseFloat(item.procedure_bill_online || 0);
  });
  totalAmount += procBillAmount; // Add procedure bill to total
  setTotals({ totalAmount, discountAmount, paidAmount, dueAmount, totalCharges, procBillAmount, procBillCash, procBillCard, procBillOnline });
}, [displayedRows]);

  // Update OPD Type - kept same
  const updateOpdType = async (item) => {
    const fd = new FormData();
    fd.append('opd_id', item.opd_id);
    fd.append('opd_patient_name', item.opd_patient_name ?? '');
    fd.append('opd_patient_title', item.opd_patient_title ?? '');
    fd.append('opd_patient_gender', item.opd_patient_gender ?? '');
    fd.append('opd_patient_mobile', item.opd_patient_mobile ?? '');
    fd.append('opd_guardien_title', item.opd_guardien_title ?? '');
    fd.append('opd_guardien_name', item.opd_guardien_name ?? '');
    fd.append('opd_address', item.opd_address ?? '');
    fd.append('opd_city', item.opd_city ?? '');
    fd.append('opd_type', 'Move to IPD');
    fd.append('opd_specality', item.opd_specality ?? '');
    fd.append('opd_concult_doctor', item.opd_concult_doctor ?? '');
    fd.append('opd_total', item.opd_total ?? 0);
    fd.append('opd_fees', item.opd_fees ?? 0);
    fd.append('opd_reg_fees', item.opd_reg_fees ?? 0);
    fd.append('opd_discount', item.opd_discount ?? 0);
    fd.append('opd_final_amt', item.opd_final_amt ?? 0);
    fd.append('opd_paid', item.opd_paid ?? 0);
    fd.append('opd_mode', item.opd_mode ?? '');
    fd.append('opd_remark', item.opd_remark ?? '');
    fd.append('opd_due', item.opd_due ?? 0);
    fd.append('opd_user', item.opd_user ?? '');
    fd.append('opd_uhid', item.opd_uhid ?? '');
    fd.append('opd_datetime', item.opd_datetime ?? new Date().toISOString());
    fd.append('opd_items', JSON.stringify([]));
    fd.append('opd_comps', JSON.stringify([]));

    try {
      const response = await axios.post(AppConst.BASE_URL + AppConst.addOpdUrl, fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      if (response.data.status) {
        toast.success(response.data.success || 'OPD Type updated successfully!');
      } else {
        toast.error(response.data.error || 'Failed to update OPD Type.');
      }
    } catch (err) {
      console.error("Error updating OPD Type:", err);
      toast.error("An error occurred while updating the OPD Type. Please try again.");
    }
  };

  // moveToIpd - kept same
  // const moveToIpd = async (item) => {
  //   if (!window.confirm(`Are you sure you want to move patient ${item.opd_patient_name} to IPD?`)) {
  //     return;
  //   }

  //   const fd = new FormData();
  //   fd.append('opd_id', item.opd_id);
  //   fd.append('ipd_uhid', item.opd_uhid ?? '');
  //   fd.append('ipd_patient_title', item.opd_patient_title ?? '');
  //   fd.append('ipd_reg_date', item.opd_datetime ?? '');
  //   fd.append('ipd_patient_name', item.opd_patient_name ?? '');
  //   fd.append('ipd_patient_gender', item.opd_patient_gender ?? '');
  //   fd.append('ipd_patient_mobile', item.opd_patient_mobile ?? '');
  //   fd.append('ipd_guardien_name', item.opd_guardien_name ?? '');
  //   fd.append('ipd_address', item.opd_address ?? '');
  //   fd.append('opd_uhid_move', item.opd_uhid ?? '');
  //   fd.append('ipd_type', 'OPD');
  //   fd.append('ipd_age', item.opd_guardien_age ?? '');
  //   fd.append('ipd_specality', item.opd_specality ?? '');
  //   fd.append('ipd_user', 1 ?? 1);
  //   fd.append('ipd_remarks', 'Moved from OPD');
  //   fd.append('ipd_refer_doctor', item.opd_concult_doctor);

  //   const ldataLocal = JSON.parse(localStorage.getItem("data"));
  //   fd.append('ipd_user', ldataLocal?.user_id ?? '');

  //   try {
  //     const response = await axios.post(AppConst.BASE_URL + AppConst.addIpdUrl, fd, {
  //       headers: { 'Content-Type': 'multipart/form-data' },
  //     });

  //     if (response.data.status) {
  //       updateOpdType(item);
  //       toast.success(response.data.success);
  //       await initData();
  //     } else {
  //       toast.error(response.data.error || "Failed to move patient.");
  //     }
  //   } catch (err) {
  //     console.error("Error moving patient to IPD:", err);
  //     toast.error("An error occurred. Please try again.");
  //   }
  // };


  // moveToIpd using SweetAlert2 confirmation + loading + refresh
const moveToIpd = async (item) => {
  if (!item || !item.opd_id) return;

  const confirm = await Swal.fire({
    title: `Move ${item.opd_patient_name || 'this patient'} to IPD?`,
    text: "This will create an IPD record and update OPD status. Are you sure?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, Move",
    cancelButtonText: "Cancel",
    reverseButtons: true,
    allowOutsideClick: () => !Swal.isLoading()
  });

  if (!confirm.isConfirmed) {
    return; // user cancelled
  }

  // Build FormData (same fields as before)
  const fd = new FormData();
  fd.append('opd_id', item.opd_id);
  fd.append('ipd_uhid', item.opd_uhid ?? '');
  fd.append('ipd_patient_title', item.opd_patient_title ?? '');
  fd.append('ipd_reg_date', item.opd_datetime ?? '');
  fd.append('ipd_patient_name', item.opd_patient_name ?? '');
  fd.append('ipd_patient_gender', item.opd_patient_gender ?? '');
  fd.append('ipd_patient_mobile', item.opd_patient_mobile ?? '');
  fd.append('ipd_guardien_name', item.opd_guardien_name ?? '');
  fd.append('ipd_address', item.opd_address ?? '');
  fd.append('opd_uhid_move', item.opd_uhid ?? '');
  fd.append('ipd_type', 'OPD');
  fd.append('ipd_age', item.opd_guardien_age ?? '');
  fd.append('ipd_specality', item.opd_specality ?? '');
  fd.append('ipd_user', 1 ?? 1);
  fd.append('ipd_remarks', 'Moved from OPD');
  fd.append('ipd_refer_doctor', item.opd_concult_doctor);

  // include actual logged-in user if available
  try {
    const ldataLocal = JSON.parse(localStorage.getItem("data") || "{}");
    if (ldataLocal?.user_id) fd.set('ipd_user', ldataLocal.user_id);
  } catch (e) {
    // ignore parse error, leave ipd_user as-is
  }

  try {
    // show loading modal
    Swal.fire({
      title: 'Moving to IPD...',
      text: 'Please wait',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    const response = await axios.post(AppConst.BASE_URL + AppConst.addIpdUrl, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    Swal.close(); // close loading

    if (response?.data?.status) {
      // backend success -> update OPD type and refresh list
      try {
        // call your existing updateOpdType to set OPD -> Move to IPD
        // (it will call the API to update OPD row)
        await updateOpdType(item);
      } catch (e) {
        console.warn("updateOpdType failed after addIpd", e);
      }

      // refresh OPD list from server
      try {
        await initData();
      } catch (e) {
        console.warn("initData refresh failed", e);
      }

      // show success and force page reload to ensure everything refreshed
      await Swal.fire({
        title: 'Moved!',
        text: response.data.success || 'Patient moved to IPD successfully.',
        icon: 'success',
        confirmButtonText: 'OK'
      });

      // full page reload so UI everywhere is in sync (you can remove this if you prefer just initData())
      window.location.reload();
    } else {
      // server returned status false
      Swal.fire({
        title: 'Move Failed',
        text: response?.data?.error || 'Failed to move patient to IPD.',
        icon: 'error'
      });
    }
  } catch (err) {
    console.error("Error moving to IPD:", err);
    Swal.close();
    Swal.fire({
      title: 'Error',
      text: 'An error occurred while moving to IPD. Check console or try again.',
      icon: 'error'
    });
  }
};


  // ---------- PDF helpers (kept exactly as you provided) ----------
  const fetchConfigData = async () => {
    try {
      const res = await axios.post(`${AppConst.BASE_URL + AppConst.getconfig}?config_type=lab`);
      if (res.data.status) {
        const data = res.data;
        setHeaderLogo(data.header_logo);
        setWatermarkLogo(data.logo || '');
        setFooterImage(data.footer_logo);
      }
    } catch (err) {
      console.error("Error fetching config:", err);
    }
  };

  const imageUrlToBase64 = async (url) => {
    if (!url) return null;
    try {
      const response = await fetch(url);
      if (!response.ok) return null;
      const blob = await response.blob();
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error("Error converting image to Base64:", error);
      return null;
    }
  };

  const numberToWords = (num) => {
    if (num === undefined || num === null || num === '') return '';
    num = Number(num);
    if (isNaN(num)) return '';
    num = Math.round(num);
    const a = ['', 'one ', 'two ', 'three ', 'four ', 'five ', 'six ', 'seven ', 'eight ', 'nine ', 'ten ', 'eleven ', 'twelve ', 'thirteen ', 'fourteen ', 'fifteen ', 'sixteen ', 'seventeen ', 'eighteen ', 'nineteen '];
    const b = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
    if (num.toString().length > 9) return 'overflow';
    const n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    if (!n) return '';
    let str = '';
    str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'crore ' : '';
    str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'lakh ' : '';
    str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'thousand ' : '';
    str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'hundred ' : '';
    str += (n[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) : '';
    return str.charAt(0).toUpperCase() + str.slice(1).trim();
  };

  const generateInvoicePdf = async (invoiceData) => {
    if (!invoiceData) {
      toast.error("No invoice data available to generate PDF.");
      return;
    }
    const doc = new jsPDF('p', 'pt', 'a4');
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const headerImageBase64 = await imageUrlToBase64(invoiceData.config.headerLogoUrl);

    if (headerImageBase64) {
      doc.addImage(headerImageBase64, 'PNG', 0, 0, pageWidth, 60);
    }

    doc.setFontSize(9);
    doc.setFont('helvetica', 'bold');
    doc.setDrawColor(0);
    doc.rect(40, 70, pageWidth - 80, 20);
    doc.text("Invoice Cum Receipt", pageWidth / 2, 84, { align: 'center' });

    const leftX = 50;
    const rightX = pageWidth / 2 + 20;
    let y = 105;

    const printDetail = (label, value, x, y) => {
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(8);
      doc.text(`${label} :`, x, y);
      doc.text(`${value || ''}`, x + 70, y);
    };

    printDetail("UHID No", invoiceData.patient.uhid, leftX, y);
    printDetail("Patient Name", invoiceData.patient.name, leftX, y += 12);
    printDetail("Age/Sex", invoiceData.patient.ageSex, leftX, y += 12);
    printDetail("Patient Address", invoiceData.patient.address, leftX, y += 12);
    printDetail("Payment Method", invoiceData.payment.method, leftX, y += 12);

    y = 105;
    printDetail("Bill Date", invoiceData.bill.date, rightX, y);
    printDetail("Bill No", invoiceData.bill.no, rightX, y += 12);
    printDetail("Token No", invoiceData.bill.token, rightX, y += 12);
    printDetail("Receipt No", invoiceData.bill.receiptNo, rightX, y += 12);
    printDetail("Visit Date", invoiceData.bill.visitDate, rightX, y += 12);

    autoTable(doc, {
      startY: y + 15,
      head: [['S.No', 'Doctor / Degree / Designation / Reg. No.', 'Amount']],
      body: invoiceData.transactions.map(tx => [
        tx.sno || '',
        tx.description || '',
        tx.amount ? tx.amount.toFixed(2) : '0.00'
      ]),
      theme: 'grid',
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: 0,
        fontStyle: 'bold',
        lineWidth: 0.3
      },
      styles: {
        fontSize: 8,
        cellPadding: 2
      },
      columnStyles: {
        0: { cellWidth: 35, halign: 'center' },
        1: { cellWidth: pageWidth - 180 },
        2: { cellWidth: 70, halign: 'right' }
      },
      margin: { left: 40, right: 40 },
      tableWidth: 'auto'
    });

    let finalY = doc.lastAutoTable.finalY + 5;

    const labelX = pageWidth - 230;
    const colonX = pageWidth - 120;
    const valueX = pageWidth - 60;

    const printSummaryLine = (label, value) => {
      finalY += 14;
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(8);
      doc.text(label, labelX, finalY);
      doc.text(':', colonX, finalY);
      doc.setFont('helvetica', 'bold');
      doc.text(value, valueX, finalY, { align: 'right' });
    };

    printSummaryLine("Registration Charges", invoiceData.summary.regCharges.toFixed(2));
    printSummaryLine("Bill Amount (Round Off)", invoiceData.summary.billAmount.toFixed(2));
    printSummaryLine("Discount (%)", invoiceData.summary.discount.toFixed(0));
    printSummaryLine("Paid", invoiceData.summary.paid.toFixed(2));
    printSummaryLine("Due", invoiceData.summary.due.toFixed(2));

    finalY += 18;
    doc.setFontSize(8);
    doc.text(`Sum of Rs. ${invoiceData.summary.totalInWords} only Received`, 40, finalY);

    const pdfBlobUrl = doc.output('bloburl');
    window.open(pdfBlobUrl, '_blank');
  };

  // keep handlePrint unchanged (exact logic you provided earlier)
  const handlePrint = (record, doctors) => {
    const selectedDoctor = doctors.find(doc => doc.user_id === record.opd_concult_doctor);
    const doctorDescription = selectedDoctor
      ? `${selectedDoctor.fname} / ${selectedDoctor.doc?.doc_degree || ''} / ${selectedDoctor.doc?.doc_specality || ''}`
      : 'Doctor Details Not Found';

    const token = record.opd_token_no;
    const patientNameForReceipt = record.opd_patient_name || "N/A";
    const timeStamp = Date.now();

    const dynamicBillNo = `${timeStamp}-${token}`;
    const dynamicReceiptNo = `${patientNameForReceipt}-${token}`;

    const invoiceData = {
      config: { headerLogoUrl: headerLogo, watermarkLogoUrl: watermarkLogo },
      patient: {
        uhid: record.opd_uhid || 'N/A',
        name: `${record.opd_patient_title || ''} ${record.opd_patient_name}`,
        ageSex: `${record.opd_guardien_age || '30'}Y / ${record.opd_patient_gender}`,
        address: record.opd_address || 'N/A',
      },
      payment: { method: record.opd_mode },
      bill: {
        date: record.opd_datetime,
        no: dynamicBillNo,
        token: token,
        receiptNo: dynamicReceiptNo,
        visitDate: record.opd_datetime,
        opdNo: record.opd_id || 'N/A',
      },
      transactions: [
        {
          sno: 1,
          description: doctorDescription,
          amount: parseFloat(record.opd_fees || 0)
        }
      ],
      summary: {
        regCharges: parseFloat(record.opd_reg_fees || 0),
        billAmount: parseFloat(record.opd_total || 0),
        discount: parseFloat(record.opd_discount || 0),
        paid: parseFloat(record.opd_paid || 0),
        due: parseFloat(record.opd_due || 0),
        totalInWords: numberToWords(record.opd_final_amt || 0)
      }
    };

    generateInvoicePdf(invoiceData);
  };

  const generatePrescriptionPdf = async (prescriptionData) => {
    if (!prescriptionData) {
      console.error("No prescription data available to generate PDF.");
      return;
    }

    const doc = new jsPDF('p', 'pt', 'a4');
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const margin = 40;

    const headerImageBase64 = await imageUrlToBase64(prescriptionData.config.headerLogoUrl);
    if (headerImageBase64) {
      doc.addImage(headerImageBase64, 'PNG', 0, 0, pageWidth, 80);
    }

    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.setDrawColor(0);
    doc.setLineWidth(1.5);
    doc.rect(margin, 90, pageWidth - (margin * 2), 25);
    doc.text("OPD PRESCRIPTION", pageWidth / 2, 107, { align: 'center' });

    let y = 135;
    const rowHeight = 18;
    const labelWidth = 65;

    const printDetail = (label, value, x, yPos) => {
      doc.setFontSize(9);
      doc.setFont('helvetica', 'bold');
      doc.text(label, x, yPos);
      doc.setFont('helvetica', 'normal');
      doc.text(`:  ${value || ''}`, x + labelWidth, yPos);
    };

    const col1X = margin + 5;
    const col2X = margin + 270;
    const col3X = margin + 420;

    printDetail("UHID No", prescriptionData.patient.uhid, col1X, y);
    printDetail("OPD No", prescriptionData.bill.opdNo, col2X, y);
    printDetail("Date", prescriptionData.bill.date, col3X, y);
    y += rowHeight;

    printDetail("Name", prescriptionData.patient.name, col1X, y);
    printDetail("Age", `${prescriptionData.patient.age || 49}Y`, col2X, y);
    printDetail("Sex", prescriptionData.patient.sex, col3X, y);
    y += rowHeight;

    printDetail("Address", prescriptionData.patient.address, col1X, y);
    printDetail("Mobile No", prescriptionData.patient.mobile, col2X, y);
    y += rowHeight;

    doc.setFontSize(9);
    doc.setFont('helvetica', 'bold');
    doc.text("Doctor", col1X, y);
    doc.setFont('helvetica', 'normal');
    const doctorDetails = doc.splitTextToSize(`:  ${prescriptionData.doctor.details}`, 200);
    doc.text(doctorDetails, col1X + labelWidth, y);
    printDetail("Doctor Reg No", prescriptionData.doctor.regNo, col2X, y);

    y += rowHeight;
    doc.setLineWidth(0.8);
    doc.line(0, y, pageWidth, y);

    let contentStartY = y + 30;
    const leftSectionWidth = 150;

    doc.setLineWidth(1.5);
    doc.line(leftSectionWidth, y, leftSectionWidth, pageHeight - margin - 20);

    const historyY = contentStartY + 150;
    const adviceY = historyY + 230;
    doc.setLineWidth(0.5);
    doc.line(margin, historyY, leftSectionWidth, historyY);
    doc.line(margin, adviceY, leftSectionWidth, adviceY);

    doc.setFontSize(9);
    doc.setFont('helvetica', 'bold');
    doc.text("VITALS :", margin + 5, contentStartY + 15);
    doc.text("Complaint :", margin + 5, historyY + 15);
    doc.text("Instruction : ", margin + 5, adviceY + 15);

    doc.setFontSize(22);
    doc.setFont('times', 'bold');
    doc.text("Rx", leftSectionWidth + 15, contentStartY + 25);

    const leftColX = margin + 5;
    const leftColWidth = leftSectionWidth - 10;
    const itemFontSize = 8;
    doc.setFontSize(itemFontSize);
    doc.setFont('helvetica', 'normal');

    let vitalsY = contentStartY + 30;
    if (formData.tests1 && formData.tests1.length > 0) {
      formData.tests1.forEach((item, idx) => {
        const vitalName = document.getElementById(`vital45${idx}`)?.selectedOptions[0]?.text || '';
        const vitalValue = document.getElementById(`vitalval45${idx}`)?.value || '';
        const text = `${idx + 1}. ${vitalName}: ${vitalValue}`;
        const wrappedText = doc.splitTextToSize(text, leftColWidth);
        if (vitalsY + (wrappedText.length * (itemFontSize + 2)) < historyY) {
          doc.text(wrappedText, leftColX, vitalsY);
          vitalsY += wrappedText.length * (itemFontSize + 2);
        }
      });
    }

    let complaintsY = historyY + 30;
    if (formData.comps && formData.comps.length > 0) {
      formData.comps.forEach((item, idx) => {
        const compText = document.getElementById(`comp_txt${idx}`)?.value || '';
        const text = `${idx + 1}. ${compText}`;
        const wrappedText = doc.splitTextToSize(text, leftColWidth);
        if (complaintsY + (wrappedText.length * (itemFontSize + 2)) < adviceY) {
          doc.text(wrappedText, leftColX, complaintsY);
          complaintsY += wrappedText.length * (itemFontSize + 2);
        }
      });
    }

    let instructionsY = adviceY + 30;
    if (formData.inspections && formData.inspections.length > 0) {
      formData.inspections.forEach((item, idx) => {
        const inspText = document.getElementById(`insp_txt${idx}`)?.value || '';
        const text = `${idx + 1}. ${inspText}`;
        const wrappedText = doc.splitTextToSize(text, leftColWidth);
        doc.text(wrappedText, leftColX, instructionsY);
        instructionsY += wrappedText.length * (itemFontSize + 2);
      });
    }

    const pdfBlobUrl = doc.output('bloburl');
    window.open(pdfBlobUrl, '_blank');
  };

  // Handle print prescription wrapper (kept same)
  const handlePrintPrescription = (record, doctors) => {
    const selectedDoctor = doctors.find(doc => doc.user_id === record.opd_concult_doctor);
    const doctorDescription = selectedDoctor
      ? `${selectedDoctor.fname || ''} ${selectedDoctor.lname || ''} (${selectedDoctor.doc?.doc_degree || ''}, ${selectedDoctor.doc?.doc_specality || ''})`
      : 'N/A';
    const doctorRegNo = selectedDoctor ? selectedDoctor.doc?.doc_reg_no || 'N/A' : 'N/A';

    const prescriptionData = {
      config: { headerLogoUrl: headerLogo },
      patient: {
        uhid: record.opd_uhid || 'N/A',
        name: `${record.opd_patient_title || ''} ${record.opd_patient_name || ''}`.trim(),
        address: record.opd_address || 'N/A',
        age: record.opd_guardien_age || 'N/A',
        sex: record.opd_patient_gender || 'N/A',
        mobile: record.opd_patient_mobile || 'N/A'
      },
      bill: {
        opdNo: record.opd_id || 'N/A',
        date: record.opd_datetime ? new Date(record.opd_datetime).toLocaleDateString('en-GB') : 'N/A',
      },
      doctor: {
        details: doctorDescription,
        regNo: doctorRegNo
      }
    };

    generatePrescriptionPdf(prescriptionData);
  };

  useEffect(() => {
    const handlePointerDown = (e) => {
      if (openDropdownId === null) return;
      const el = document.getElementById(`dropup-${openDropdownId}`);
      if (el && !el.contains(e.target)) setOpenDropdownId(null);
    };

    const handleKey = (e) => {
      if (e.key === "Escape") setOpenDropdownId(null);
    };

    document.addEventListener("pointerdown", handlePointerDown);
    document.addEventListener("keydown", handleKey);
    return () => {
      document.removeEventListener("pointerdown", handlePointerDown);
      document.removeEventListener("keydown", handleKey);
    };
  }, [openDropdownId]);

  const handleToggle = (e, id) => {
    e.stopPropagation();
    setOpenDropdownId(prev => (prev === id ? null : id));
  };
// robust user name resolver (put inside component)
function resolveUserDisplay(row) {
  if (!row) return '';

  // 1) Prefer backend-provided friendly fields
  const preNames = [
    row.user_display,        // your backend sets this in get_opd_list()
    row.last_used,           // sometimes backend uses this
    row.last_used_name,      // other variants
    row.opd_user_name,       // possible backend alias
    row.user_name,
    row.fname,
    row.ipd_bill_user_name,
    row.opd_uhid_user // unlikely but keep flexible
  ];
  for (const p of preNames) {
    if (p !== undefined && p !== null && String(p).trim() !== '') return String(p).trim();
  }

  // 2) Try many id fields and lookup in cached lists (formData.doc / formData.docs)
  const idCandidates = [
    row.last_used_id,
    row.opd_user,
    row.opd_user_id,
    row.user_id,
    row.last_used_by,
    row.ipd_user,
    row.opd_userid
  ].map(x => x === undefined || x === null ? '' : String(x).trim()).filter(Boolean);

  // try doctors/users from formData.doc (OPD) or formData.docs (IPD)
  const usersArray = formData.doc || formData.docs || [];
  for (const id of idCandidates) {
    // 2a) direct lookup in prebuilt map object if you have it
    if (typeof doctorsMap === 'object' && doctorsMap && doctorsMap[String(id)]) {
      return doctorsMap[String(id)];
    }
    // 2b) search the raw arrays for a matching id field
    const found = usersArray.find(u => {
      if (!u) return false;
      const keys = [
        u.user_id, u.id, u.userId, u.doctor_id, u.doc?.doc_parent, u.doc?.doc_user
      ].map(k => k === undefined || k === null ? '' : String(k).trim());
      return keys.includes(String(id));
    });
    if (found) {
      return (found.fname || found.name || found.full_name || found.username || (found.doc && found.doc.doc_name) || String(id)).toString();
    }
  }

  // 3) fallback to any name fields on row (opd_fname, fname, username)
  if (row.fname || row.username) return String(row.fname || row.username);

  // 4) last resort: return an id string for debugging
  return idCandidates.length ? `User #${idCandidates[0]}` : '';
}
// Confirm before editing (use existing editable checks)
const confirmEdit = async (row) => {
  if (!row) return;

  // Block if moved to IPD
  if (row.opd_type === "Move to IPD") {
    await Swal.fire({ icon: 'error', title: 'Cannot Edit', text: 'This record has been moved to IPD and cannot be edited.' });
    return;
  }

  // Check if editable
  if (!isEditableRecord(row)) {
    // Give user a clear reason: show when the record was created/modified
    const recTime = row.opd_datetime ? parseToLocalDate(row.opd_datetime) : null;
    const modifiedAt = row.modified_at ? parseToLocalDate(row.modified_at) : null;
    let info = 'This record is not editable.';
    if (modifiedAt) {
      const unlock = new Date(modifiedAt.getTime() + 24 * 60 * 60 * 1000);
      info = `This record was modified on ${formatDateTime(modifiedAt)}. Editing is locked for 24 hours from the last modification. You can edit after ${formatDateTime(unlock)}.`;
    } else if (recTime) {
      const unlock = new Date(recTime.getTime() + 24 * 60 * 60 * 1000);
      info = `Patient was registered on ${formatDateTime(recTime)}. Editing is locked for 24 hours from registration. You can edit after ${formatDateTime(unlock)}.`;
    }
    await Swal.fire({ icon: 'info', title: 'Edit Locked', html: info });
    return;
  }

  // show confirmation
  const result = await Swal.fire({
    title: 'Edit this record?',
    html: `<b>${row.opd_patient_name || 'Patient'}</b><br/>Reg No: ${row.opd_id || '-'}<br/>Do you want to open the edit screen?`,
    icon: 'question',
    showCancelButton: true,
    confirmButtonText: 'Yes, Edit',
    cancelButtonText: 'Cancel',
    reverseButtons: true
  });

  if (result.isConfirmed) {
    try {
      sessionStorage.setItem("opd_dt", JSON.stringify(row));
    } catch (e) {
      console.warn("sessionStorage set failed for opd_dt", e);
    }
    window.location.href = "/opd_registrations";
  }
};

// Confirm before deleting (admin-only check performed before calling)
const confirmDelete = async (row) => {
  if (!row) return;

  // extra safety: do not delete if moved to IPD
  if (row.opd_type === "Move to IPD") {
    await Swal.fire({ icon: 'error', title: 'Cannot Delete', text: 'This record has been moved to IPD and cannot be deleted.' });
    return;
  }

  // ask final confirmation
  const res = await Swal.fire({
    title: 'Are you sure?',
    html: `Delete <b>${row.opd_patient_name || 'this record'}</b> (Reg No: ${row.opd_id || '-'})?<br/><span style="color:#d33">This action cannot be undone.</span>`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it',
    cancelButtonText: 'Cancel',
    confirmButtonColor: '#d33',
    reverseButtons: true
  });

  if (res.isConfirmed) {
    try {
      await delItem(row); // your existing delItem already calls API and refreshes
      // After successful delItem the toast is shown inside delItem; if you want extra modal:
      // await Swal.fire({ icon: 'success', title: 'Deleted', text: 'Record deleted successfully.' });
    } catch (err) {
      console.error("confirmDelete -> delItem failed", err);
      Swal.fire({ icon: 'error', title: 'Delete Failed', text: 'Could not delete the record. Check console.' });
    }
  }
};

  // DataTable columns
  const columns = [
    {
      name: 'Action',
      cell: row => {
        const editable = isEditableRecord(row);
        const roleId = String(getLoggedRoleId() ?? '').trim();
        const userIsAdmin = roleId === '1';
    
        return (
          <>
            <button
              type="button"
              onClick={async (e) => {
                e.preventDefault();
                e.stopPropagation();
                await confirmEdit(row);
              }}
             className="btn btn-sm btn-outline-warning"
              style={{ opacity: editable ? 1 : 0.5, pointerEvents: editable ? "auto" : "none" }}
              disabled={!editable}
            >
              <i className="ri-pencil-fill"></i>
            </button>
    
            &nbsp;&nbsp;
    
            <button
              type="button"
              onClick={async (e) => {
                e.preventDefault();
                e.stopPropagation();
    
                // check admin quickly here as an extra safety (you may keep UX check prior)
                if (!userIsAdmin) {
                  toast.error("Only admin can delete.");
                  return;
                }
    
                await confirmDelete(row);
              }}
              className="btn btn-sm btn-outline-danger"
              style={{ opacity: userIsAdmin ? 1 : 0.5, pointerEvents: userIsAdmin ? "auto" : "none" }}
              disabled={!userIsAdmin}
            >
              <i className="ri-delete-bin-5-fill fs-16"></i> 
            </button>
          </>
        );
      },
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: '170px'
    },
    {
      name: '',
      width: '230px',
      cell: row => {
        // ✅ Check if procedure bill exists for this patient
        const hasProcedureBill = row.procedure_bill_id || row.has_procedure_bill;
        
        return (
          <>
            <button
              className="btn btn-sm btn-primary me-2"
              onClick={(e) => { 
                e.stopPropagation(); 
                openDetails(row); 
              }}
              title="View Details"
            >
              View
            </button>
            <button
              className={`btn btn-sm ${hasProcedureBill ? 'btn-warning' : 'btn-success'}`} // ✅ Warning for edit, success for add
              onClick={(e) => {
                e.stopPropagation();
                
                // ✅ Close dropdown FIRST
                setOpenDropdownId(null);
                
                // Small delay to ensure state updates
                setTimeout(() => {
                  const mappedData = {
                    opd_id: row.opd_id,
                    ipd_bill_uhid: row.opd_uhid,
                    ot_uhid_no: row.opd_uhid,
                    ipd_no: row.opd_id,
                    ipd_bill_patient_name: row.opd_patient_name,
                    ipd_bill_patient_age: row.opd_guardien_age || row.opd_patient_age,
                    ipd_bill_patient_gender: row.opd_patient_gender,
                    ipd_bill_patient_phone: row.opd_patient_mobile,
                    ipd_bill_patient_address: row.opd_address,
                    procedure_bill_id: row.procedure_bill_id, // ✅ Pass existing bill ID if available
                    ...row
                  };
                  setProcedurePatientData(mappedData);
                  setShowProcedureBill(true);
                }, 10);
              }}
              title={hasProcedureBill ? "Edit Procedure Bill" : "Add Procedure Bill"}
            >
              {hasProcedureBill ? (
                <>
                  <i className="ri-edit-line me-1"></i>
                  Edit Procedure Bill
                </>
              ) : (
                <>
                  <i className="ri-add-line me-1"></i>
                  Add Procedure Bill
                </>
              )}
            </button>
          </>
        );
      },
      ignoreRowClick: true,
      allowOverflow: true,
      button: true
    },



    
    {
      name: 'Done',
      width: '90px',
      cell: row => {
        const isDone = Number(row.done || 0) === 1;
        return (
          <button
            className={`btn btn-sm ${isDone ? 'btn-success' : 'btn-outline-primary'}`}
            onClick={(e) => { e.stopPropagation(); if(!isDone) toggleDone(row); }}
            disabled={isDone}
          >
            {isDone ? 'Done' : 'Mark Done'}
          </button>
        );
      },
      ignoreRowClick: true,
      allowOverflow: true,
      button: true
    },
  {
      name: '',
      width: '48px',
      cell: row => (
        <div id={`dropup-${row.opd_id}`} className="dropup z-index-dropdown-fix">
          <button
            className="btn btn-link text-muted p-0"
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              setOpenDropdownId(prev => (prev === row.opd_id ? null : row.opd_id));
            }}
            aria-expanded={openDropdownId === row.opd_id}
          >
            <i className="ri-more-2-fill fs-18"></i>
          </button>

          <ul
            className={`dropdown-menu dropdown-menu-end shadow ${openDropdownId === row.opd_id ? 'show' : ''}`}
            style={{
              display: openDropdownId === row.opd_id ? 'block' : 'none',
              position: 'relative',
              inset: 'auto auto 0px 0px',
              margin: 0,
            }}
          >
            <li>
              <button className="dropdown-item" onClick={() => handlePrintPrescription(row, formData.doc)}>
                Print Prescriptions
              </button>
            </li>
            <li>
              <button className="dropdown-item" onClick={() => handlePrint(row, formData.doc)}>
                Print Invoice
              </button>
            </li>
            {row.opd_type === "Move to IPD" ? null : (
              <li>
                <button className="dropdown-item" onClick={() => moveToIpd(row)}>
                  Move to Ipd
                </button>
              </li>
            )}
          </ul>
        </div>
      )
    },
   
    { 
      name: 'Sn.',
      // use cell instead of selector so we can access row index (provided by DataTable)
      cell: (row, rowIndex) => {
        const zeroBasedPage = Number(pageNo) || 0;
        // ensure pageSize fallback is 15 (not 10)
        const size = Number(pageSize) || 15;
        const serial = zeroBasedPage * size + (rowIndex + 1);
        return <div>{serial}</div>;
      },
      width: '60px',
      sortable: false
    },
    
    
    { name: 'UHID', selector: row => row.opd_uhid, sortable: true,width: '130px' },
    { name: 'Reg. Number', selector: row => row.opd_id, sortable: true,width: '120px' },
    { name: 'Reg. Date', selector: row => formatDateTime(row.opd_datetime), sortable: true,width: '190px' },
    { name: 'Patient Name', selector: row => `${row.opd_patient_title || ''} ${row.opd_patient_name || ''}`.trim(), sortable: true,width: '170px' },
    { 
      name: 'Consult Doctor',
      selector: row => row.consult_doctor_name || getDoctorNameById(row.opd_concult_doctor),
      sortable: true,
      wrap: true,
      width: '190px'
    },
    { name: 'OPD Total', selector: row => row.opd_final_amt, right: true,width: '110px'},
    { name: 'Paid Amount', selector: row => row.opd_paid, right: true,width: '210px' },
    { name: 'Due Amount', selector: row => row.opd_due, right: true,width: '110px' },
    { name: 'Status', selector: row => row.opd_type, cell: row => <span className="badge bg-primary-subtle text-primary fs-6">{row.opd_type}</span> },
    {
      name: 'Last Used',
      selector: row => resolveUserDisplay(row),
      sortable: true,
      width: '160px'
    },
    
   
    
    
  ];

  const rows = displayedRows;

  const conditionalRowStyles = [
    {
      when: row => row.opd_type === "Move to IPD",
      style: {
        backgroundColor: '#caefd3ff',
      },
    },
  ];
  const customStyles = {
    headCells: {
      style: {
        backgroundColor: '#f1f5fb',
        color: '#405189',
        fontSize: '15px',      // larger header text
        fontWeight: '700',
        paddingLeft: '14px',
        paddingRight: '14px',
      }
    },
    rows: {
      style: {
        fontSize: '16px', // row font size
        minHeight: '58px',
      },
    },
    cells: {
      style: {
        paddingLeft: '14px',
        paddingRight: '14px',
        fontSize: '15px',      // larger body text
        lineHeight: '25px'
      }
    },
  };
  
  return (
    <div className="page-content">



<style>{`
  .marquee-wrap {
    overflow: hidden;
    position: relative;
    width: 160px;
    height: 28px;
    display: inline-block;
    vertical-align: middle;
  }
  .marquee {
    display: inline-block;
    white-space: nowrap;
    padding-left: 100%;
    box-sizing: content-box;
    animation: marquee 8s linear infinite;
    font-weight: 700;
    color: #ffffff;
    background: #198754;
    border-radius: 6px;
    padding: 4px 10px;
    line-height: 20px;
  }
  .marquee:hover {
    animation-play-state: paused;
  }

  @keyframes marquee {
    0% { transform: translateX(0%); }
    100% { transform: translateX(-100%); }
  }

  @media (max-width: 600px) {
    .marquee { animation-duration: 5s; }
    .marquee-wrap { width: 120px; height: 26px; }
  }

  /* ✅ Hide view button by default; show on row hover */
  .opd-table .view-btn {
    visibility: hidden;
    opacity: 0;
    transform: translateY(0);
    transition: opacity .12s ease, visibility .12s ease, transform .12s ease;
  }
  
  .opd-table .rdt_TableRow:hover .view-btn {
    visibility: visible;
    opacity: 1;
    transform: translateY(0);
  }
  
  .view-btn { 
    pointer-events: auto; 
  }

  /* ✅ CRITICAL: Hide all dropdowns when modal is open */
  .dropdown-menu.show {
    z-index: 1040;
  }

  /* ✅ Force hide dropdowns when procedure modal is showing */
  body:has(.modal.show) .dropdown-menu {
    display: none !important;
    visibility: hidden !important;
  }

  body:has(.modal.show) .dropup {
    display: none !important;
    visibility: hidden !important;
  }

  /* ✅ Alternative approach - target specific dropdown */
  .page-content:has(.modal.show) .dropdown-menu,
  .page-content:has(.modal.show) .dropup,
  .page-content:has(.modal.show) .z-index-dropdown-fix {
    display: none !important;
    visibility: hidden !important;
  }
`}</style>
      <style>{`
  /* Hide view button by default; show on row hover */
  .opd-table .view-btn {
    visibility: hidden;
    opacity: 0;
    transform: translateY(0);
    transition: opacity .12s ease, visibility .12s ease, transform .12s ease;
  }
  /* react-data-table-component uses .rdt_TableRow for rows */
  .opd-table .rdt_TableRow:hover .view-btn {
    visibility: visible;
    opacity: 1;
    transform: translateY(0);
  }
  /* make sure the view button area doesn't collapse */
  .view-btn { pointer-events: auto; }
`}</style>
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="card" id="orderList">
              <div className="card-header border-0">
                <div className="row align-items-center gy-3">
                  <div className="col-sm">
                    <h5 className="card-title mb-0">OPD Registrations</h5>
                  </div>
                  <div className="col-sm-auto">
                    <div className="d-flex gap-1 flex-wrap">
                      <a href="javascript:void(0)" onClick={(e) => {
                        e.preventDefault();
                        sessionStorage.removeItem("opd_dt");
                        window.location.href = "/opd_registrations";
                      }}>
                        <button type="button" className="btn btn-success add-btn">
                          <i className="ri-add-line align-bottom me-1"></i> New Entry
                        </button>
                      </a>
                      <button className="btn btn-soft-danger" id="remove-actions">
                        <i className="ri-delete-bin-2-line"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card-body border border-dashed border-end-0 border-start-0">
                <form>
                  <div className="row g-3">
                    <div className="col-md-2">
                      <label className="form-label">From</label>
                      <input
    className="form-control"
    type="date"
    name="from"
    onChange={(e) => {
      const val = e.target.value;
      setFormData(prev => ({ ...prev, from: val }));
      // small delay to allow state update then fetch
      setTimeout(() => initData(), 80);
    }}
    value={formData.from}
  />
                    </div>
                    <div className="col-md-2">
                      <label className="form-label">To</label>
                      <input
    className="form-control"
    type="date"
    name="to"
    onChange={(e) => {
      const val = e.target.value;
      setFormData(prev => ({ ...prev, to: val }));
      setTimeout(() => initData(), 80);
    }}
    value={formData.to}
  />
                    </div>


                    

                    <div className="col-md-2">
                      <label className="form-label"></label>
                      <div className="search-box" style={{ display: "flex" }}>
                        {/* <button type="button" onClick={initData} className="btn btn-success">Search</button> */}
                        &nbsp;&nbsp;&nbsp;
                        <button type="button" onClick={() => {
                          setFormData(prev => ({
                            ...prev,
                            search_key: "",
                            from: todayDate,
                            to: todayDate,
                          }));
                          setTimeout(initData, 100);
                        }} className="btn btn-info">Clear</button>
                      </div>
                    </div>
                    

                    <div className="col-md-3" style={{ zIndex: 1050 }}>
  <label className="form-label">Doctor</label>
  <Select
  options={doctorOptions}
  value={
    doctorOptions.find(
      opt => String(opt.value) === String(formData.selectedDoctorId)
    ) || null
  }
  onChange={(selectedOption) => {
    if (isDoctorLogin) return; // 🔒 doctor cannot change
    setFormData(prev => ({
      ...prev,
      selectedDoctorId: selectedOption ? selectedOption.value : ''
    }));
  }}
  placeholder={isDoctorLogin ? "Doctor (Locked)" : "All Doctors"}
  isClearable={!isDoctorLogin}
  isSearchable={!isDoctorLogin}
  isDisabled={isDoctorLogin}   // 🔥 IMPORTANT
/>

</div>








<div className="col-md-3" style={{ textAlign: "right" }}>
  <label className="form-label"></label>
  <div className="search-box">
    <input 
      className="form-control search" 
      placeholder="Search..." 
      type="text"
      name="search_key" 
      onChange={(e) => {
        const value = e.target.value;
        setFormData(prev => ({ ...prev, search_key: value }));
      }} 
      onKeyUp={(e) => {
        // ✅ Trigger search on every keystroke with small delay
        if (e.target.value !== formData.search_key) {
          clearTimeout(window.searchTimeout);
          window.searchTimeout = setTimeout(() => {
            initData({ page: 0, size: pageSize });
          }, 500);
        }
      }}
      value={formData.search_key} 
    />
    <i className="ri-search-line search-icon"></i>
  </div>
</div>
                    
                  </div>

                  
                </form>
              </div>

              <br />

              <div className="card-body pt-0">
                <div className="table-responsive table-card mb-1">
                <DataTable
  columns={columns}
  data={rows}
  customStyles={customStyles}
  className="opd-table"
  noHeader
  pagination
  paginationServer
  paginationPerPage={pageSize}
  paginationRowsPerPageOptions={[15, 20, 25, 50]}
  paginationTotalRows={totalCount}
  paginationDefaultPage={pageNo + 1}
  onChangePage={(newPage) => {
    const zeroBased = Math.max(0, newPage - 1);
    setPageNo(zeroBased);
    initData({ page: zeroBased, size: pageSize });
  }}
  onChangeRowsPerPage={(newPerPage, newPage) => {
    const zeroBased = Math.max(0, (newPage ? newPage - 1 : 0));
    setPageSize(newPerPage);
    setPageNo(zeroBased);
    initData({ page: zeroBased, size: newPerPage });
  }}
  highlightOnHover
  conditionalRowStyles={conditionalRowStyles}
  persistTableHead
  // ✅ Add expandable rows
  expandableRows
  expandableRowsComponent={ExpandedActions}
  expandableRowExpanded={() => true}  // Always show actions
  expandOnRowClicked={false}  // Don't toggle on row click
/>




                </div>

                <div className="d-flex justify-content-between align-items-center">
                  <div className="pagination-wrap hstack gap-2">
                    <div className="text-muted">
                      <strong>Total Amount:</strong> {totals.totalAmount.toFixed(2)} &nbsp;|&nbsp;
                      <strong>Discount Amount:</strong> {totals.discountAmount.toFixed(2)} &nbsp;|&nbsp;
                      <strong>Paid Amount:</strong> {totals.paidAmount.toFixed(2)} &nbsp;|&nbsp;
                      <strong>Due Amount:</strong> {totals.dueAmount.toFixed(2)}  &nbsp;|&nbsp;
                      <strong>Total Register Charges:</strong> {totals.totalCharges.toFixed(2)} &nbsp;|&nbsp;
<strong>Proc Bill:</strong> {(totals.procBillAmount || 0).toFixed(2)} &nbsp;|&nbsp;
<strong>Proc Cash:</strong> {(totals.procBillCash || 0).toFixed(2)} &nbsp;|&nbsp;
<strong>Proc Card:</strong> {(totals.procBillCard || 0).toFixed(2)} &nbsp;|&nbsp;
<strong>Proc Online:</strong> {(totals.procBillOnline || 0).toFixed(2)}
                    </div>
                  </div>
                  <div className="pagination-wrap hstack gap-2">
                    {/* <a className="page-item pagination-prev" href="javascript:void(0)"
                      onClick={(e) => {
                        e.preventDefault();
                        if (formData.page_no > 0) {
                          setFormData(prev => ({ ...prev, page_no: prev.page_no - 1 }));
                          setTimeout(initData, 100);
                        }
                      }}>Previous</a> */}

                    {/* <a className="page-item pagination-next" href="javascript:void(0)"
                      onClick={(e) => {
                        e.preventDefault();
                        setFormData(prev => ({ ...prev, page_no: prev.page_no + 1 }));
                        setTimeout(initData, 100);
                      }}>Next</a> */}
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      {showProcedureBill && procedurePatientData && (
  <ProcedureBillModal
    patientData={procedurePatientData}
    onClose={() => {
      setShowProcedureBill(false);
      setProcedurePatientData(null);
      setOpenDropdownId(null); // ✅ Close any dropdowns
      
      // Refresh the OPD list after closing modal
      setTimeout(() => {
        initData({ page: pageNo, size: pageSize });
      }, 100);
    }}
    image={headerLogo}
    watermarkImage={watermarkLogo}
    footerImage={footerImage}
  />
)}
    </div>
  );
}

export default OpdPataintList;
